import {createAction} from 'redux-actions';
import {getQcJobsStatuses} from '@pluto/rest';
import {QCStatusEnum} from '../../../QCWorkflow/QCFilters/QCFiltersType';

export const QC_JOBS_STATUSES_SET = 'QC_JOBS_STATUSES_SET';
export type QCJobsStatusesPayload = QCStatusEnum[];

export const setQcJobsStatusesAction = createAction<Promise<QCJobsStatusesPayload>>(QC_JOBS_STATUSES_SET, async () => {
    return await getQcJobsStatuses();
});
